/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mesafeli_S6_Bddk_EmInputs */

const tr_mesafeli_s6_bddk_em = /** @type {(inputs: Mesafeli_S6_Bddk_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`hiçbir otomatik tahsilat yapılmaz`)
};

const en_mesafeli_s6_bddk_em = /** @type {(inputs: Mesafeli_S6_Bddk_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`no automatic charge is made`)
};

const de_mesafeli_s6_bddk_em = /** @type {(inputs: Mesafeli_S6_Bddk_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`kein automatischer Einzug`)
};

const ru_mesafeli_s6_bddk_em = /** @type {(inputs: Mesafeli_S6_Bddk_EmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`автоматические списания не производятся`)
};

/**
* | output |
* | --- |
* | "no automatic charge is made" |
*
* @param {Mesafeli_S6_Bddk_EmInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const mesafeli_s6_bddk_em = /** @type {((inputs?: Mesafeli_S6_Bddk_EmInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mesafeli_S6_Bddk_EmInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_mesafeli_s6_bddk_em(inputs)
	if (locale === "de") return de_mesafeli_s6_bddk_em(inputs)
	if (locale === "ru") return ru_mesafeli_s6_bddk_em(inputs)
	return tr_mesafeli_s6_bddk_em(inputs)
});